import styled from 'styled-components'

export default styled.div`
  > * + * {
    margin-top: ${props => props.spacing || 15}px;
  }
`
